import Vue from 'vue';
//import Vuetify from 'vuetify/lib';
import Vuetify from 'vuetify/lib/framework';

import { dashboardThemeColors } from '../../dashboard-config/dashboard-config.js';
const themeColorsLight = dashboardThemeColors.light;

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ['~/assets/scss/variables.scss'],
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        ...themeColorsLight
      }
    }
  }
});
